/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_843d41d4"]'><cube-modal ref="__mpx_ref_modal__" type="onConfirm" title="我是标题~" content="我是正文正文" confirm-btn="一个按钮" :show-close-icon="(true)" :mask-closable="(true)" @confirm='(e)=>__invoke(e, [["onConfirm"]])' @close='(e)=>__invoke(e, [["onClose"]])'/><cube-button @_click="onTap">modal-with-close</cube-button></div></template>
/* styles */
/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_843d41d4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_843d41d4"}
  /** script content **/
  require("./modal-with-close.mpx.js?isComponent&outputPath=components%2Fmodal-with-close843d41d4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./modal-with-close.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fmodal-with-close843d41d4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_843d41d4"],
    ctorType: "component",
    outputPath: "components/modal-with-close843d41d4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-modal':getComponent(require("../../../packages/mpx-cube-ui/src/components/modal/index.mpx?isComponent&outputPath=components%2Findex317b3b4c%2Findex")),'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>